import { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

// Hardcoded users for demonstration
const USERS = [
  {
    id: 1,
    email: 'admin@example.com',
    password: 'password123',
    name: 'Admin User',
    role: 'admin',
  },
  {
    id: 2,
    email: 'user@example.com',
    password: 'password123',
    name: 'Regular User',
    role: 'user',
  },
];

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for user in localStorage (simulating token persistence)
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (email, password) => {
    return new Promise((resolve, reject) => {
      // Simulate API call delay
      setTimeout(() => {
        const user = USERS.find(
          (u) => u.email === email && u.password === password
        );
        
        if (user) {
          // Create a user object without the password
          const authenticatedUser = {
            id: user.id,
            email: user.email,
            name: user.name,
            role: user.role,
          };
          
          // Store in state and localStorage
          setCurrentUser(authenticatedUser);
          localStorage.setItem('user', JSON.stringify(authenticatedUser));
          resolve(authenticatedUser);
        } else {
          reject(new Error('Invalid email or password'));
        }
      }, 500);
    });
  };

  const logout = () => {
    setCurrentUser(null);
    localStorage.removeItem('user');
  };

  const value = {
    currentUser,
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
}; 